module.exports = __webpack_public_path__ + "static/img/kg01.ba752eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/home/gamelist/kg01.png
// module id = LG5D
// module chunks = 43